import { z } from 'zod';
import { Id, IsoDateTime, TenantId } from './common.ts';

/** Append-only, hash-chained audit entry (per tenant). Payload is redacted before storage. */
export const AuditEntry = z
  .object({
    id: Id,
    time: IsoDateTime,
    tenantId: TenantId,
    taskId: Id.optional(),
    actionId: Id.optional(),
    /** Principal id or workload name. */
    actor: z.string().min(1),
    /** e.g. `gateway.denied`, `approval.decided`, `registry.killswitch.changed`. */
    kind: z.string().min(1),
    payload: z.record(z.string(), z.unknown()),
    hash: z.string().min(1),
    prevHash: z.string().nullable(),
  })
  .meta({ id: 'AuditEntry' });
export type AuditEntry = z.infer<typeof AuditEntry>;
